export default {"src":"/_next/static/media/ahm-pet-insurance-logo.d2812dd2.svg","height":69,"width":225};